import React, { useState } from "react";

const SeatingCalculator = () => {
  const [rows, setRows] = useState("");
  const [columns, setColumns] = useState("");
  const [totalSeats, setTotalSeats] = useState(null);

  const calculateSeats = () => {
    setTotalSeats(rows * columns);
  };

  return (
    <div className="p-6 bg-gray-100 rounded-lg shadow-lg mx-auto mt-5">
      <h2 className="text-xl font-bold text-center text-blue-600">Classroom Seating Arrangement</h2>
      <input type="number" placeholder="Number of Rows" className="border p-2 w-full mt-3" onChange={(e) => setRows(e.target.value)} />
      <input type="number" placeholder="Seats per Row" className="border p-2 w-full mt-3" onChange={(e) => setColumns(e.target.value)} />
      <button className="mt-4 bg-blue-500 text-white py-2 px-4 rounded w-full" onClick={calculateSeats}>Calculate</button>
      {totalSeats && <div className="mt-3 text-center text-lg">Total Seats: <span className="font-bold text-green-600">{totalSeats}</span></div>}
    </div>
  );
};

export default SeatingCalculator;
